import useSWR from 'swr';
import { fetcher } from '../swr/fetchers';

/**
 * Return session token for the currently logged in user, or null if no user is logged in
 */
export const useToken = () => {
  const { data, error } = useSWR<string>('/v1/token', fetcher());

  if (error) {
    return null;
  }

  return data;
};
